import PageHeader from "@/components/PageHeader";
import KioskMenu from "@/components/KioskMenu";
import CtaBand from "@/components/CtaBand";
import { useSeo } from "@/lib/seo";

export default function FacilitiesPage() {
  useSeo({
    title: "Facilities — Kiosk & Bar | Cool Runnings Cape Town",
    description:
      "Kiosk & bar favourites, cold drinks and grab-and-go treats — refuel between rides at Cool Runnings Toboggan Park, Cape Town. Free entry, no booking needed.",
    keywords:
      "Cool Runnings kiosk, Cool Runnings bar Cape Town, toboggan park food, snacks drinks Tygervalley, grab and go Cape Town attraction",
    image: "/og/facilities.jpg",
  });
  return (
    <>
      <PageHeader
        goodgirlTitle
        pageName="Facilities"
        eyebrow="The Kiosk & Bar"
        title="FACILITIES"
        subline="Kiosk classics, cold drinks and bar favourites — grab-and-go on the day, no booking needed."
        image="/park-kiosk.jpg"
      />
      <KioskMenu />
      <CtaBand />
    </>
  );
}
